import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import AutoFocus from '../AutoFocus'

import panelStyle from 'Styles/panel.css'
import style from './style.css'

function getAnswer (curCard) {
  let answer
  if (curCard.testTerm) {
    answer = curCard.testTerm
  } else {
    answer = curCard.choices[curCard.correctAnswerIndex]
  }
  return answer
}

function getScore (points) {
  return (
    <span className={style.score}>
      +{points}
      <span className={style.pointsLabel}>
        pts
      </span>
    </span>
  )
}

function getFeedback (curCard) {
  if (curCard.choices_fb) {
    return curCard.choices_fb[curCard.correctAnswerIndex]
  } else if (curCard.feedbackCorrect) {
    return curCard.feedbackCorrect
  }
}

export default function SuccessModal (props) {
  const answer = getAnswer(props.curCard)
  let score = 'Correct'
  let aria = 'Correct'
  if (props.curCard.pointsAchieved) {
    const points = Math.round(parseFloat(props.curCard.pointsAchieved) * 10) / 10
    aria = `+${points} points. Your current score is ${props.score.activityScore} out of ${props.score.scoreTarget}.`
    score = getScore(points)
  }

  const feedback = getFeedback(props.curCard)
  return (
    <div
      data-test-id="SuccessModal"
      className={classnames(panelStyle.large, style.container)}
      tabIndex="0"
    >
      <AutoFocus check={answer}>
        <h2 className={style.score}>{score}</h2>
      </AutoFocus>
      <p className={style.feedbackIntro}>{props.curCard.feedbackIntro} The correct answer is:</p>
      <h2
        data-test-id="correctAnswerSuccessModal"
        className={style.textAnswerModal}
        dangerouslySetInnerHTML={{ __html: answer }}
      />
      {feedback
        ? (
          <h3
            data-test-id="answerInfoSuccessModal"
            className={style.textInfoModal}
            dangerouslySetInnerHTML={{ __html: feedback }}
          />
          )
        : null
      }
      <div className={style.challenge}>
        <button
          onClick={props.onChallenge}
          className={classnames('btn-cdl-secondary', style.challenge)}
          data-test-id="showAnswerModalBtn"
        >
          Report an error with this Question
        </button>
      </div>
    </div>
  )
}
SuccessModal.propTypes = {
  curCard: PropTypes.object.isRequired,
  onChallenge: PropTypes.func.isRequired,
  score: PropTypes.object.isRequired
}
